var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('v-btn',{on:{"click":_vm.OpenAddCoursePricing}},[_vm._v("Add Pricing")]),_c('app-add-course-pricing',{ref:"CoursePricing",attrs:{"dialog":_vm.AddCoursePricing},on:{"close":_vm.CloseDialog}}),_c('app-pricing-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }